import logo from '@/assets/logo.svg';
import { IntelligenceCore } from '@/components/ui/IntelligenceCore';
import { useI18n } from '@/hooks/useI18n';
import { useShell } from '@/hooks/useShell';

export const HeroSection = () => {
  const { t, locale } = useI18n();
  const { shell } = useShell();

  const authorLine = shell?.hero?.author_line || 'By Syrym Zhanzhigitov';
  const subtitle = shell?.hero?.subtitle?.[locale] || t('home.eyebrow');
  const description = shell?.hero?.description?.[locale] || t('home.subtitle');
  const asideTitle = shell?.hero?.aside_title?.[locale] || t('home.side.title');
  const asideText = shell?.hero?.aside_text?.[locale] || t('home.side.text');

  return (
    <header className="hero">
      <div className="brand-copy">
        <img className="brand-logo" src={logo} alt={t('brand.name')} />
        <p className="brand-author">{authorLine}</p>
        <p className="brand-platform">{subtitle}</p>
        <div className="sub">{description}</div>
      </div>

      <IntelligenceCore
        showWords
        caption={{ title: t('home.core.title'), subtitle: t('home.core.subtitle') }}
      />

      <aside className="brand-side">
        <span className="side-eyebrow">{t('home.side.eyebrow')}</span>
        <h2>{asideTitle}</h2>
        <p>{asideText}</p>
      </aside>
    </header>
  );
};
